var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKingBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3188_78334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4729 9.0266L17.8398 6.24694C17.8454 6.20913 17.8406 6.1705 17.8257 6.13528C17.8109 6.10005 17.7867 6.06958 17.7557 6.0472C17.7247 6.02482 17.6881 6.01139 17.65 6.00838C17.6119 6.00537 17.5737 6.01289 17.5396 6.03013L16.3499 6.95853C16.3277 6.97701 16.3019 6.9906 16.274 6.99842C16.2462 7.00623 16.2171 7.00811 16.1885 7.00391C16.1599 6.99972 16.1325 6.98955 16.1081 6.97406C16.0838 6.95858 16.0629 6.93814 16.0469 6.91406L14.8711 5.19623C14.8518 5.17388 14.8279 5.15595 14.8011 5.14365C14.7742 5.13136 14.745 5.125 14.7155 5.125C14.6859 5.125 14.6567 5.13136 14.6299 5.14365C14.603 5.15595 14.5791 5.17388 14.5598 5.19623L13.384 6.91406C13.3681 6.93814 13.3472 6.95858 13.3228 6.97406C13.2984 6.98955 13.271 6.99972 13.2425 7.00391C13.2139 7.00811 13.1847 7.00623 13.1569 6.99842C13.1291 6.9906 13.1033 6.97701 13.081 6.95853L11.8913 6.05237C11.8572 6.03513 11.819 6.0276 11.7809 6.03061C11.7428 6.03363 11.7063 6.04706 11.6753 6.06944C11.6443 6.09182 11.6201 6.12229 11.6052 6.15751C11.5904 6.19274 11.5855 6.23137 11.5911 6.26918L11.9581 9.0266H17.4729Z",
    stroke: "#77838D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3188_78334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.65625 16.1484V14.1563C6.65625 13.804 6.79618 13.4662 7.04525 13.2171C7.29432 12.9681 7.63214 12.8281 7.98438 12.8281H13.2969C13.6491 12.8281 13.9869 12.9681 14.236 13.2171C14.4851 13.4662 14.625 13.804 14.625 14.1563V16.1484",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 16.1484V14.1563C14.625 13.804 14.7649 13.4662 15.014 13.2171C15.2631 12.9681 15.6009 12.8281 15.9531 12.8281H21.2656C21.6179 12.8281 21.9557 12.9681 22.2048 13.2171C22.4538 13.4662 22.5938 13.804 22.5938 14.1563V16.1484",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4349 16.1484H22.8151C23.2848 16.1484 23.7352 16.335 24.0673 16.6671C24.3994 16.9992 24.586 17.4496 24.586 17.9193V22.125H4.66406V17.9193C4.66406 17.4496 4.85063 16.9992 5.18273 16.6671C5.51482 16.335 5.96524 16.1484 6.4349 16.1484Z",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 22.125V24.7813",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5859 22.125V24.7813",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 16.1484V10.1719C22.5938 9.81964 22.4538 9.48182 22.2048 9.23275C21.9557 8.98368 21.6179 8.84375 21.2656 8.84375H7.98438C7.63214 8.84375 7.29432 8.98368 7.04525 9.23275C6.79618 9.48182 6.65625 9.81964 6.65625 10.1719V16.1484",
    stroke: "#77838D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3188_78334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.50002,
    height: 8.50002,
    fill: "white",
    transform: "translate(10.375 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3188_78334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.25,
    height: 21.25,
    fill: "white",
    transform: "translate(4 6.1875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingBed);
export default __webpack_public_path__ + "static/media/king_bed.6ff9f2a5.svg";
export { ForwardRef as ReactComponent };